import React from "react";
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";
import { scale, verticalScale } from "../../utils/scale";
import color from "../../constants/color";
import ContactIcon from "../../assets/svg/ContactIcon";
import testIds from "@constants/testIds";

export function CustomerRow(props) {
  return (
    <View style={styles.mainContainer}>
      <View style={styles.contactContainer}>
        <Text numberOfLines={2} style={styles.nameText}>
          {props.data.user_name}
        </Text>
        <View style={styles.contactIconContainer}>
          {props.showIcon ? <ContactIcon /> : null}
          <Text
            style={{
              fontSize: scale(14),
              marginLeft: props.showIcon ? scale(10) : 0,
              lineHeight: 20,
              color: "rgba(0, 0, 0, 0.56)",
            }}
          >
            {props.data.user_phone}
          </Text>
        </View>
      </View>
      <TouchableOpacity
        testID={testIds.Khud_Ke_Liye_Order_Kare}
        style={[
          styles.orderTouchable,
          props.disabled ? { backgroundColor: color.silver } : {},
        ]}
        onPress={props.orderClick}
        disabled={props.disabled}
      >
        <Text style={styles.orderText}>
          {props.customer ? "ऐड करें" : "आर्डर करें"}
        </Text>
      </TouchableOpacity>
    </View>
  );
}

export const Seprator = () => {
  return <View style={styles.sepratorView} />;
};
const styles = StyleSheet.create({
  sepratorView: {
    height: 1,
    backgroundColor: "rgba(0, 0, 0, 0.1)",
    width: "100%",
  },
  mainContainer: {
    height: verticalScale(67),
    width: "100%",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#FFFFFF",
  },

  contactContainer: {
    width: scale(245),
    marginLeft: scale(15),
    marginVertical: verticalScale(10),
  },
  nameText: {
    fontSize: scale(16),
    width: "97%",
    lineHeight: 22,
  },
  contactIconContainer: {
    flexDirection: "row",
    width: "100%",
  },

  orderTouchable: {
    height: verticalScale(36),
    width: scale(96),
    borderRadius: scale(6),
    backgroundColor: color.primary,
    justifyContent: "center",
    alignItems: "center",
  },
  orderText: { color: "white", fontSize: scale(16), lineHeight: scale(20) },
});
